import { createStyles, Theme } from '@material-ui/core/styles';

export const styles = ({ spacing }: Theme) =>
  createStyles({
    root: {},
    actionRow: {
      fontWeight: 500,
    },
    labelRoot: {},
    labelError: {},
    list: {
      padding: 0,
    },
    listItem: {
      padding: spacing(1.5, 3),
    },
    listItemDisabled: {},
    notFoundText: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    optionsList: {
      padding: spacing(0),
    },
    notFoundResults: {},
  });
